import React from "react"
import { Link } from "react-router-dom"
import "./NotFound.css"

function NotFound() {
  return (
    <div className='NotFound'>
      <div className='NotFound-content'>
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>Sorry, the page you are looking for does not exist.</p>
        <Link to='/' className='NotFound-link'>
          Return to Home
        </Link>
      </div>
    </div>
  )
}

export default NotFound

